<template>
  <PageView
    :main-title="$t('ModifProjet.title')"
    :sub-title="subTitle"
    :no-sub-title-expected="hasSubTitle"
  >
    <ContentView :wide-screen="true">
      <ModifProjetView />
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import PageView from "@/views/commons/PageView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import ModifProjetView from "./ModifProjetView.vue"

export default defineComponent({
  name: "ModifProjetPage",
  components: {
    PageView,
    ContentView,
    ModifProjetView,
  },
  data() {
    return {
      hasSubTitle: true,
      subTitle: "" as string | undefined,
    }
  },
})
</script>
